import React, { useMemo } from 'react';

import { formatDateString } from '~libs/dayjs';

import Icon, { faCheck, faXmark } from '~components/icon';
import TooltipPortal from '~weekly-planner/components/TooltipPortal';

interface ComponentProps {
  id: string;
  row: any;
}

const BudgetIcon: React.FC<ComponentProps> = ({ id, row }) => {
  const { service_type_id, purchase_order_number, client_budget_id } = row || {};

  const matchingService = useMemo(() => {
    const validServices = row?._meta?.validServices ?? [];
    if (!validServices.length) return null;

    if (purchase_order_number) {
      return validServices.find((svc: any) => svc.purchase_order_number === purchase_order_number) ?? null;
    }

    if (service_type_id) {
      return validServices.find((svc: any) => svc.service_type_id === service_type_id) ?? null;
    }

    return null;
  }, [row, purchase_order_number, service_type_id]);

  const budget = matchingService?.budget ?? (client_budget_id ? { id: client_budget_id } : null);
  const { start_date, end_date } = budget || {};
  const hasBudget = Boolean(budget?.id);

  // Tooltip & icon
  const indicator = hasBudget ? <Icon icon={faCheck} color="green" /> : <Icon icon={faXmark} color="red" />;

  let tooltipContent = 'No budget found';
  if (hasBudget) {
    tooltipContent =
      start_date && end_date
        ? `Budget found: ${formatDateString(start_date)} → ${formatDateString(end_date)}`
        : 'Budget found';
  }

  return (
    <>
      <div className="d-flex justify-content-center" id={`budget-icon-${id}`}>
        {indicator}
      </div>
      <TooltipPortal targetId={`budget-icon-${id}`} content={tooltipContent} />
    </>
  );
};

export default BudgetIcon;
